export default __webpack_public_path__ + "static/media/ststephen.19fe5a12.jpg";